




















































































































































import Component from 'vue-class-component';
import { IDictionary } from '@/entities/dictionary.interface';
import { IFormControl } from '@/entities/form.interface';
import { EditPage } from '@/components/base/edit/edit-page';
import agentsApi from '@/api/agents.api';
import companiesApi from '@/api/companies.api';
import { IListItem } from '../../../entities/list-item.interface';
import { ICompany } from '../../../entities/offices/company.interface';
import {
    IAgentDetail,
    IAgentSiteLink
} from '../../../entities/agents/agent-detail.interface';
import OfficeSelect from '@/containers/account/offices/office-select.vue';
import * as types from '@/store/types';
import { mapGetters } from 'vuex';
import { IAgentEdit } from '../../../entities/agents';
import { IConfirm, INote, NoteType } from '@/entities';
import * as utils from '@/utils';
import sitesApi from '@/api/sites.api';

const passwordDefaultValidator = 'confirmed:passwordConfirm'; // TODO move to entities valid-rules.ts

@Component({
    components: {
        'app-office-field': OfficeSelect
    },
    computed: mapGetters({
        superAdminPermissions: types.AUTH_HAS_SUPERADMIN_PERMISSIONS,
        adminPermissions: types.AUTH_HAS_ADMIN_PERMISSIONS,
        companyId: types.AUTH_GET_COMPANY_ID
    })
})
export default class AgentsEdit extends EditPage {
    public parentPath: string = '/app/agents';

    public sites: IListItem[] = [];

    //  public companies: IListItem[] = [];
    public formState: IDictionary<IFormControl> = {
        officeId: {
            key: 'officeId',
            label: 'Office',
            value: '',
            validators: 'required'
        },
        firstName: {
            key: 'firstName',
            label: `First Name`,
            value: '',
            validators: 'required'
        },
        lastName: {
            key: 'lastName',
            label: `Last Name`,
            value: '',
            validators: 'required'
        },
        // email: {
        //     key: 'email',
        //     label: 'Email',
        //     value: '',
        //     validators: 'required|email'
        // },
        username: {
            key: 'username',
            label: 'Username',
            value: '',
            validators: 'required|max:10'
        },
        password: {
            key: 'password',
            label: 'Password',
            value: '',
            validators: passwordDefaultValidator
        },
        passwordConfirm: {
            key: 'passwordConfirm',
            label: 'Confirm Password',
            value: '',
            validators: ''
        },
        mustRead: {
            key: 'mustRead',
            label: 'Must Read (optional)',
            value: ''
        },
        active: {
            key: 'active',
            label: 'Activated',
            value: false
        },
        hidden: {
          key: 'hidden',
          label: 'Hidden',
          value: false
        },
        siteIds: {
            key: 'siteIds',
            label: 'Sites',
            value: []
        }
    };

    public get officeDisable() {
        return !this.isNew && !this.superAdminPermissions;
    }

    protected adminPermissions: boolean;
    protected superAdminPermissions: boolean;
    protected companyId: number | null;

    public async created() {
        await super.created();

        // companiesApi.list().then((items: ICompany[]) => {
        //     this.companies = items.map((x) => {
        //         return {value: x.id, heading: x.officeName};
        //     });
        // });

        if (this.isNew) {
            this.formState = {
                ...this.formState,
                password: {
                    ...this.formState.password,
                    validators: passwordDefaultValidator + '|required'
                },
                passwordConfirm: {
                    ...this.formState.passwordConfirm,
                    validators: 'required'
                }
            };
            this.formState.active.value = true;
        } else {
            const siteIds = this.model.sites
                .filter((x) => x.enable)
                .map((x) => x.siteId);
            this.formState.siteIds.value = siteIds;
            this.sites = this.model.sites.map((x: IAgentSiteLink) => {
                return { value: x.siteId, heading: x.sitename };
            });
        }
    }

    public detail(companyId: number): Promise<IAgentDetail> {
        return agentsApi.get(companyId);
    }

    public create(body: IAgentEdit): Promise<number> {
        if (!this.adminPermissions) {
            body.officeId = this.companyId;
        }
        this.$store.dispatch(types.APPROVE_QUERY_UNAPPROVED_COUNT);
        return agentsApi.create(body);
    }

    public update(body: any): Promise<number> {
        body.sites = this.formState.siteIds.value.map((x) => {
            return { siteId: x, enable: true };
        });
        return agentsApi.update(this.id, body);
    }

    public deleteAgent() {
        let afterFn = async (closeFn: () => void) => {
            try {
                await agentsApi.delete(this.id);
                let note: INote = {
                    total: 1,
                    guid: utils.guid(),
                    type: NoteType.Success,
                    heading: 'Deleted',
                    body: `Agent "${
                        this.formState.username.value
                    }" has been successfully deleted`
                };

                this.$store.dispatch(types.ADD_TEMP_NOTE, note);
                this.$router.push(this.parentPath);
                //   this.items = this.items.filter((x) => x.id !== item.id);
            } finally {
                closeFn();
            }
        };

        let payload: IConfirm = {
            heading: `Do you want to delete the agent "${
                this.formState.username.value
            }" and all it's statistics and logs? `,
            afterFn
        };

        this.$store.dispatch(types.SHOW_CONFIRM, payload);
        this.$store.dispatch(types.APPROVE_QUERY_UNAPPROVED_COUNT);
    }
}
